export default __webpack_public_path__ + "static/media/daewoo-chevrolet.29a89dda.jpg";